module.exports = __webpack_public_path__ + "img/logo-ttb.ea524a33.svg";